import { render, staticRenderFns } from "./Pager.vue?vue&type=template&id=78fdf9b2&scoped=true&lang=pug&"
import script from "./Pager.vue?vue&type=script&lang=coffee&"
export * from "./Pager.vue?vue&type=script&lang=coffee&"
import style0 from "./Pager.vue?vue&type=style&index=0&id=78fdf9b2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fdf9b2",
  null
  
)

export default component.exports